import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var DmsViewerFieldEditTracker = /*#__PURE__*/function () {
  function DmsViewerFieldEditTracker(webViewer) {
    _classCallCheck(this, DmsViewerFieldEditTracker);
    this.webViewer = webViewer;
    this.elements = [];
    this.eventHandlers = new Map();
    this.disposed = false;
    this.focusedInput = void 0;
    this.onPageComplete = this.onPageComplete.bind(this);
    this.webViewer.Core.documentViewer.addEventListener('pageComplete', this.onPageComplete);
  }
  return _createClass(DmsViewerFieldEditTracker, [{
    key: "flush",
    value: function () {
      var _flush = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.disposed) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.sendFocusOutEventIfInEdit();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function flush() {
        return _flush.apply(this, arguments);
      }
      return flush;
    }()
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }
      this.webViewer.Core.documentViewer.removeEventListener('pageComplete', this.onPageComplete);
      this.cleanInputReferences();
      delete this.eventHandlers;
      delete this.elements;
      this.disposed = true;
    }
  }, {
    key: "onPageComplete",
    value: function onPageComplete(pageNumber) {
      this.storeInputElements(this.webViewer, pageNumber);
    }
  }, {
    key: "sendFocusOutEventIfInEdit",
    value: function sendFocusOutEventIfInEdit() {
      if (!this.focusedInput) {
        return;
      }
      var focusoutEvent = new Event('focusout');
      this.focusedInput.dispatchEvent(focusoutEvent);
    }
  }, {
    key: "storeInputElements",
    value: function storeInputElements(webViewer, pageNumber) {
      var _webViewer$UI$iframeW;
      var body = (_webViewer$UI$iframeW = webViewer.UI.iframeWindow) === null || _webViewer$UI$iframeW === void 0 ? void 0 : _webViewer$UI$iframeW.document;
      var documentContentContainer = body === null || body === void 0 ? void 0 : body.querySelector('.document-content-container');
      if (documentContentContainer) {
        actWhenReady(this.getInputs(documentContentContainer, pageNumber), function (elements) {
          return elements.length > 0;
        }, this.addFocusEventListeners(pageNumber), 500);
      }
    }
  }, {
    key: "getInputs",
    value: function getInputs(documentContentContainer, pageNumber) {
      return function () {
        var result = [];
        var widgetsContainer = documentContentContainer.querySelector("div#pageWidgetContainer".concat(pageNumber));
        if (widgetsContainer) {
          result.push.apply(result, _toConsumableArray(widgetsContainer.querySelectorAll('textarea')));
          result.push.apply(result, _toConsumableArray(widgetsContainer.querySelectorAll('input')));
        }
        return result;
      };
    }
  }, {
    key: "addFocusEventListeners",
    value: function addFocusEventListeners(pageNumber) {
      var _this = this;
      return function (inputElements) {
        inputElements.forEach(function (inputElement) {
          var focusInHandler = _this.focusIn.bind(_this);
          var focusOutHandler = _this.focusOut.bind(_this);
          inputElement.addEventListener('focusin', focusInHandler);
          inputElement.addEventListener('focusout', focusOutHandler);
          _this.eventHandlers.set(inputElement, [focusInHandler, focusOutHandler]);
        });
        _this.cleanPageInputsReferences(pageNumber);
        _this.elements[pageNumber - 1] = inputElements;
      };
    }
  }, {
    key: "focusIn",
    value: function focusIn($event) {
      this.focusedInput = $event.target;
    }
  }, {
    key: "focusOut",
    value: function focusOut() {
      this.focusedInput = undefined;
    }
  }, {
    key: "cleanInputReferences",
    value: function cleanInputReferences() {
      for (var index = 0; index < this.elements.length; index++) {
        this.cleanPageInputsReferences(index + 1);
      }
    }
  }, {
    key: "cleanPageInputsReferences",
    value: function cleanPageInputsReferences(pageNumber) {
      var _this2 = this;
      var pageInputElements = this.elements[pageNumber - 1];
      if (pageInputElements) {
        pageInputElements.forEach(function (element) {
          if (_this2.eventHandlers.has(element)) {
            var _ref = _this2.eventHandlers.get(element),
              _ref2 = _slicedToArray(_ref, 2),
              focusIn = _ref2[0],
              focusOut = _ref2[1];
            element.removeEventListener('focusin', focusIn);
            element.removeEventListener('focusout', focusOut);
          }
        });
      }
    }
  }]);
}();
var provider = {
  DmsViewerFieldEditTracker: DmsViewerFieldEditTracker
};
export function mockDmsViewerFieldEditTrackerProvider(mock) {
  provider = mock;
}
export function dmsViewerFieldEditTrackerConstructor() {
  return provider.DmsViewerFieldEditTracker;
}
function actWhenReady(getState, isReady, actOn, timeoutMilliseconds) {
  var _checkState = function checkState() {
    var state = getState();
    if (isReady(state)) {
      actOn(state);
    } else {
      setTimeout(_checkState, timeoutMilliseconds);
    }
  };
  _checkState();
}
